import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestAddchg } from "../../entity/EntityRequestAddchg";

export class DtoRequestAddchgsGetRes extends EntityRequestAddchg {
  public items: EntityRequestAddchg[]  = [];
}
